import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { PureComponent } from 'react';
import classnames from 'classnames';
import Modal from '../modal';
import confirmLocale from './locale/zh_CN';

var Confirm = /*#__PURE__*/function (_PureComponent) {
  _inherits(Confirm, _PureComponent);

  var _super = _createSuper(Confirm);

  function Confirm() {
    _classCallCheck(this, Confirm);

    return _super.apply(this, arguments);
  }

  _createClass(Confirm, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          prefixCls = _this$props.prefixCls,
          className = _this$props.className,
          content = _this$props.content,
          okText = _this$props.okText,
          cancelText = _this$props.cancelText,
          shape = _this$props.shape,
          onOk = _this$props.onOk,
          onCancel = _this$props.onCancel,
          locale = _this$props.locale,
          others = _objectWithoutProperties(_this$props, ["prefixCls", "className", "content", "okText", "cancelText", "shape", "onOk", "onCancel", "locale"]);

      var cls = {
        confirm: classnames(prefixCls, className, _defineProperty({}, "".concat(prefixCls, "--").concat(shape), !!shape))
      };
      return /*#__PURE__*/React.createElement("div", {
        className: cls.confirm
      }, /*#__PURE__*/React.createElement(Modal, _extends({}, others, {
        footer: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
          type: "button",
          className: "".concat(prefixCls, "__button"),
          onClick: onCancel
        }, cancelText || locale.cancelText), /*#__PURE__*/React.createElement("button", {
          type: "button",
          className: "".concat(prefixCls, "__button ").concat(prefixCls, "__button--ok"),
          onClick: onOk
        }, okText || locale.okText))
      }), content));
    }
  }]);

  return Confirm;
}(PureComponent);

Confirm.defaultProps = {
  prefixCls: 'za-confirm',
  animationType: 'zoom',
  locale: confirmLocale,
  shape: 'radius'
};
export { Confirm as default };